/* Stillness theme — interactions */
(function () {
  'use strict';

  /* Ensure Shopify.routes exists (it is normally injected by content_for_header) */
  window.Shopify = window.Shopify || {};
  window.Shopify.routes = window.Shopify.routes || { root: '/' };

  /* ---------------- Mobile menu ---------------- */
  var menuOpen = document.querySelector('[data-menu-open]');
  var menu = document.querySelector('.mobile-menu');
  var menuClose = document.querySelector('[data-menu-close]');
  function openMenu() { if (menu) { menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeMenu() { if (menu) { menu.classList.remove('is-open'); document.body.style.overflow = ''; } }
  if (menuOpen) menuOpen.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);

  /* ---------------- Shop by category dropdown ---------------- */
  var navItem = document.querySelector('.header__nav-item.has-dropdown');
  if (navItem) {
    var trigger = navItem.querySelector('.header__nav-trigger');
    var isTouch = window.matchMedia('(hover: none)').matches;
    function openDrop() { navItem.classList.add('is-open'); if (trigger) trigger.setAttribute('aria-expanded', 'true'); }
    function closeDrop() { navItem.classList.remove('is-open'); if (trigger) trigger.setAttribute('aria-expanded', 'false'); }
    if (trigger) trigger.addEventListener('click', function (e) {
      e.preventDefault();
      navItem.classList.contains('is-open') ? closeDrop() : openDrop();
    });
    if (!isTouch) {
      navItem.addEventListener('mouseenter', openDrop);
      navItem.addEventListener('mouseleave', closeDrop);
    }
    document.addEventListener('click', function (e) { if (!navItem.contains(e.target)) closeDrop(); });
  }

  /* ---------------- Cart drawer ---------------- */
  var drawer = document.getElementById('CartDrawer');
  var countEls = document.querySelectorAll('[data-cart-count]');

  function openCart() { if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
  function closeCart() { if (drawer) { drawer.classList.remove('is-open'); document.body.style.overflow = ''; } }

  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function setDrawerHTML(sectionHTML) {
    if (!sectionHTML) return;
    var doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
    var fresh = doc.querySelector('[data-cart-contents]');
    var current = drawer && drawer.querySelector('[data-cart-contents]');
    if (fresh && current) current.replaceWith(fresh);
  }

  function setLoading(on) {
    var c = drawer && drawer.querySelector('[data-cart-contents]');
    if (c) c.classList.toggle('cart-loading', on);
  }

  /* Open drawer from cart icon instead of navigating (JS only) */
  document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  });

  /* Close handlers (delegated so swapped content keeps working) */
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cart-close]');
      if (t) { e.preventDefault(); closeCart(); return; }

      var up = e.target.closest('[data-qty-up]');
      var down = e.target.closest('[data-qty-down]');
      var rm = e.target.closest('[data-remove]');
      if (up) return changeLine(up.dataset.line, 'up');
      if (down) return changeLine(down.dataset.line, 'down');
      if (rm) return changeLineQty(rm.dataset.line, 0);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeMenu(); }
  });

  function currentQty(line) {
    var lines = drawer.querySelectorAll('[data-line-item]');
    var el = lines[line - 1];
    var span = el && el.querySelector('.cart-line__qty span');
    return span ? parseInt(span.textContent, 10) || 0 : 0;
  }
  function changeLine(line, dir) {
    var q = currentQty(line);
    changeLineQty(line, dir === 'up' ? q + 1 : Math.max(0, q - 1));
  }

  function changeLineQty(line, quantity) {
    setLoading(true);
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.sections) setDrawerHTML(cart.sections['cart-drawer']);
        updateCount(cart.item_count);
      })
      .catch(function () { setLoading(false); });
  }

  /* AJAX add to cart from product form */
  var addForm = document.querySelector('form[action$="/cart/add"]');
  if (addForm) {
    addForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = addForm.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      var data = new FormData(addForm);
      data.append('sections', 'cart-drawer');
      data.append('sections_url', window.location.pathname);
      fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.sections) setDrawerHTML(res.sections['cart-drawer']);
          return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) { updateCount(cart.item_count); openCart(); })
        .catch(function () { addForm.submit(); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }

  /* ---------------- Reveal on scroll ---------------- */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { observer.observe(el); });
  }
})();
